import { Alert } from "antd";
import styles from "./DisabledFieldsAlert.module.scss";

const DisabledFieldsAlert = ({
  visible,
  className,
}: {
  visible?: boolean;
  className?: string;
}) => {
  if (!visible) return null;

  return (
    <Alert
      type="info"
      showIcon
      className={`${styles.container} ${styles[className ?? "components"]}`}
      message={`Once a template is published, certain fields are disabled for edit.
                If edits on those fields are required, please create a new template.`}
    />
  );
};

export default DisabledFieldsAlert;
